/** Three sample planner issues; uses distanceMiles + searchContainers for the same filters as other tabs. */
const issuesPlannerTestData = [
  {
    id: 'iss-01',
    severity: 'error',
    title: 'Return window expired before appointment',
    message:
      'AutoBook could not secure a slot before the terminal return window closed. Review buffer rules or extend the window.',
    container: 'HMMU4971909',
    jobRef: 'LU-1001',
    plannerType: 'Live Unload',
    detectedAt: 'Apr 6, 6:12 AM',
    distanceMiles: 19,
    searchContainers: ['HMMU4971909'],
  },
  {
    id: 'iss-02',
    severity: 'warning',
    title: 'Empty mismatch — same city fallback disabled',
    message:
      'No matching empty at the primary warehouse and same-city matching is off. Consider enabling same-city or adjust warehouse group.',
    container: 'TGHU3333333',
    jobRef: 'Job DP-1002',
    plannerType: 'Drop & Pick',
    detectedAt: 'Apr 5, 4:40 PM',
    distanceMiles: 12,
    searchContainers: ['TGHU3333333'],
  },
  {
    id: 'iss-03',
    severity: 'warning',
    title: 'Drive time exceeds distance limit',
    message:
      'Computed drive to terminal is above the current distance limit; appointment targets may be unreachable with current settings.',
    container: 'MSKU7000003',
    jobRef: 'LU-1003',
    plannerType: 'Live Unload',
    detectedAt: 'Apr 5, 11:05 AM',
    distanceMiles: 22,
    searchContainers: ['MSKU7000003'],
  },
];

export default issuesPlannerTestData;
